module.exports = __webpack_public_path__ + "img/step42_a_printer_power_connect_power_lan_cable.5031f3e0.png";